import React from 'react';
import { Progress as AntdProgress } from 'antd';

const Progress = ({ percent, status, strokeColor = '', format, style, showInfo = false, size = ['100%', 10] }) => {
  return (
    <AntdProgress
      strokeColor={strokeColor}
      percent={percent}
      status={status}
      format={format}
      showInfo={showInfo}
      style={style}
      size={size}
    />
  );
};

export default Progress;
